// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","wrapper__modal":"Modal_wrapper__modal__dQRk3","message":"Modal_message__42Q54"};